/*
高级认证页面相关api
 */
import request from '../request';

export const seniorCertificationApi = {
  // 获取就业状况数据
  getEmploymentStatusData() {
    return request.get('/gw/w/res/job_status');
  },
  // 获取行业数据
  getIndustryData() {
    return request.get('/gw/w/res/industry');
  },
  // 获取资金来源数据
  getCapitalSourceData() {
    return request.get('/gw/w/res/revenue_sources');
  },
  /*
   提交高级认证
   data => {
      apartmentNumber: "", // 公寓号
      authImgUrl1: "", // 居住证明图片地址
      authImgUrl2: "", // AML表单图片地址
      buildingNumber: "", // 建筑门牌号
      city: "", // 市
      companyName: "", // 雇主/公司名称
      countryCode: "", // 国籍
      countryName: "", // 国籍名称
      derivativeInvestment: "", // 衍生品市场投资年限
      district: "", // 区
      employerBuildingNumber: "", // 雇主建筑门牌号
      employerCity: "", // 雇主市
      employerCountryId: "", // 雇主国籍
      employerCountryName: "", // 雇主国籍名称(不用船只)
      employerDistrict: "", // 雇主区
      employerProvince: "", // 雇主省
      employerStreet: "", // // 雇主街道
      employerZipCode: "", // // 雇主邮政编码
      employmentStatus: "", // // 就业状态
      employmentName: "", // 就业状况对应的文字
      expectedInvestment: "", // // 预期投资水平
      grossAsset: "", // // 净资产价值美元
      hasInvestedStockMarket: "", // // 是否投资过股市
      industry: "", // // 行业
      industryName: "" // 行业对应的文字
      jobTitle: "", // // 职位名称
      province: "", // // 省
      sourceIncome: "", // // 收入来源
      sourceIncomeName: "" // 收入来源对应的文字
      stockMarketInvestment: "", // // 股市投资年限
      street: "", // // 街道
      understandBlockchanAssetTrade: "", // // 是否了解风险交易区块链资产
      understandDerivativeMarket: "", // // 是否了解验证品市场如何运作
      zipCode: "" // // 邮政编码
   }
    */
  advancedCertification(data) {
    return request({
      url: '/v2/u/user/advancedCertification',
      method: 'post',
      data,
    });
  },
  // 获取高级实名认证信息
  getSeniorCertificationInfo() {
    return request.get('/kyc/get/advance/info');
  },
  setAdvanceCertificationResident(data) {
    return request({
      url: '/kyc/set/advance/resident',
      method: 'post',
      data,
    });
  },
  setAdvanceCertificationEmployment(data) {
    return request({
      url: '/kyc/set/advance/employment',
      method: 'post',
      data,
    });
  },
  submitAdvanceCertification() {
    return request({
      url: '/kyc/submit/advance',
      method: 'post',
      data: {},
    });
  },
};
